import { render, staticRenderFns } from "./context-menu-button.vue?vue&type=template&id=4c1f8146&v-slot%3Aextension=true"
import script from "./context-menu-button.ts?vue&type=script&lang=js&external"
export * from "./context-menu-button.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports